import { render } from "./PricePreview.vue?vue&type=template&id=bc9f3950&scoped=true"
import script from "./PricePreview.vue?vue&type=script&lang=js"
export * from "./PricePreview.vue?vue&type=script&lang=js"

import "./PricePreview.vue?vue&type=style&index=0&id=bc9f3950&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc9f3950"]])

export default __exports__